<template>
    <div class="bg">
        <el-header style="height: 4%; display: flex;justify-content: space-between;">
            <div style="display: flex;gap:10px;">
                <img src="@/assets/favicon.png" alt="">
                <div class="header-text-left">凌丰供应商系统</div>
                <div class="pe-header-text">加工商</div>
            </div>
            <div style="width: 320px;">
                <div class="header-right">欢迎您，{{ userNme }} ({{ roleName }}) </div>
                <div class="header-right" style="color: #fff;">{{ homeDate }}</div>
            </div>
        </el-header>
        <div class="proc_nav">
            <div class="nav_left">
                <el-descriptions title="" :column="4" border>
                    <el-descriptions-item label="加工商名称" :contentStyle="{ width: '200px', }" :labelStyle="labelStyle">
                        <el-input style="width: 100%;font-size: 14px;" clearable @change="search"
                            v-model="search_obj.supplierName" placeholder="请输入加工商名称" size="small">
                        </el-input>
                    </el-descriptions-item>
                </el-descriptions>
            </div>
            <div class="nav_right">
                <div style="display: flex;">
                    <el-button size="small" type="primary" @click="search">搜索</el-button>
                </div>
            </div>
        </div>
        <div class="proc_body">
            <el-table ref="procUserTable" :data="table_data" border stripe height="100%" :header-row-style="{ height: '0' }"
                :header-cell-style="{
                    background: '#78b5ec',
                    color: '#000',
                    padding: '0',
                    fontWeight: '400',
                    textAlign: 'center',
                }" :row-style="{ height: '35px' }" :cell-style="{ padding: '2px 0' }" row-key="id"
                v-loading="table_loading">
                <el-table-column label="加工商名称" prop="supplierName" width="250" align="center" show-overflow-tooltip
                    sortable></el-table-column>
                <el-table-column label="加工能力" width="auto" align="center" show-overflow-tooltip sortable>
                    <el-table-column label="钻" prop="zuan" width="60" align="center" sortable>
                        <template slot-scope="ss">
                            <span v-if="ss.row.zuan">✔</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="铣" prop="xian" width="60" align="center" sortable>
                        <template slot-scope="ss">
                            <span v-if="ss.row.xian">✔</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="锣" prop="luo" width="60" align="center" sortable>
                        <template slot-scope="ss">
                            <span v-if="ss.row.luo">✔</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="割" prop="ge" width="60" align="center" sortable>
                        <template slot-scope="ss">
                            <span v-if="ss.row.ge">✔</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="焊" prop="han" width="60" align="center" sortable>
                        <template slot-scope="ss">
                            <span v-if="ss.row.han">✔</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="车" prop="che" width="60" align="center" sortable>
                        <template slot-scope="ss">
                            <span v-if="ss.row.che">✔</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="磨" prop="mo" width="60" align="center" sortable>
                        <template slot-scope="ss">
                            <span v-if="ss.row.mo">✔</span>
                        </template></el-table-column>
                    <el-table-column label="钣金" prop="banJin" width="70" align="center" sortable>
                        <template slot-scope="ss">
                            <span v-if="ss.row.banJin">✔</span>
                        </template></el-table-column>
                </el-table-column>
                <el-table-column label="合格率" width="300" align="center">
                    <template slot-scope="ss">
                        <div style="display: flex;justify-content: space-between;padding: 0 5px 0 0;">
                            <div style="width: 80%;margin-top: 4px;">
                                <el-progress :text-inside="true" :stroke-width="14"
                                    :color="percent_color(ss.row.passRate * 100)"
                                    :percentage="countPrecent(ss.row.passRate)" :show-text="false"></el-progress>
                            </div>
                            <div style="width: 20%;text-align: center;">
                                {{ ss.row.passRate }}%
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="准时率" width="300" align="center">
                    <template slot-scope="ss">
                        <div style="display: flex;justify-content: space-between;padding: 0 5px 0 0;">
                            <div style="width: 80%;margin-top: 4px;">
                                <el-progress :text-inside="true" :stroke-width="14"
                                    :color="percent_color(ss.row.onTimeRate * 100)"
                                    :percentage="countPrecent(ss.row.onTimeRate)" :show-text="false"></el-progress>
                            </div>
                            <div style="width: 20%;text-align: center;">
                                {{ ss.row.onTimeRate }}%
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="table-footer">
            <el-pagination background layout="sizes, prev, pager, next" :total="totalPage" @size-change="handleSizeChange"
                @current-change="change_data" :current-page="search_obj.currentPage" :page-size="search_obj.pageSize"
                :page-sizes="[10, 30, 50, 100, 200, 300, 400, 500]">
            </el-pagination>
        </div>
        <el-footer style="height: 2%; font-size: 13px;color: #fff;">© 2024 LINKFAIRTECH 版权所有</el-footer>

    </div>
</template>
  
<script>
import { formatDateYear } from '@/utils/func';
import { getProcSupplierApi } from '@/Api/procApi'
export default {
    name: 'procUser',
    components: {
    },
    data() {
        return {
            timer: '',
            homeDate: '',
            userNme: sessionStorage.getItem('userName'),
            labelStyle: { width: '85px', textAlign: 'center', color: '#4d4d4d', backgroundColor: '#fff' },
            search_obj: {
                supplierName: '',
                pageSize: 50,
                currentPage: 1
            },
            header: {
                headers: { token: sessionStorage.getItem('token') }
            },
            table_data: [],
            table_loading: false,
            genData: [],
            totalPage: 30,
            useDate: '',
            loading2: false,
            project_options: [],
            procMaterial_options: [],
            supplier_options: [],
            addname_visiable: false,
            status_list: ['未发货', '部分发货', '在途', '部分签收', '签收完成'],
            select_alias: '',
            roleName: sessionStorage.getItem('roleName'),
            flag: false,

            statusList: [
                { id: 1, name: '保存', color: 'blue' },
                { id: 2, name: '提交', color: '#ef7b15' },
                { id: 4, name: '审核', color: '#12CAD6' },
                { id: 8, name: '签收', color: 'green' },
                { id: -4, name: '不通过', color: 'red' },
            ],
            other_show: false,

        }
    },
    computed: {
        dateRange1: {
            get() {
                return [this.search_obj.startCreateTime, this.search_obj.endCreateTime];
            },
            set(value) {
                if (value == null) {
                    this.search_obj.startCreateTime = '';
                    this.search_obj.endCreateTime = '';
                } else {
                    this.search_obj.startCreateTime = value[0];
                    this.search_obj.endCreateTime = value[1];

                }
            }
        },
        dateRange2: {
            get() {
                return [this.search_obj.startDeadline, this.search_obj.endDeadline];
            },
            set(value) {
                if (value == null) {
                    this.search_obj.startDeadline = '';
                    this.search_obj.endDeadline = '';
                } else {
                    this.search_obj.startDeadline = value[0];
                    this.search_obj.endDeadline = value[1];
                }
            }
        },
    },
    methods: {
        formatDateYear,
        //显示时间
        showTime() {
            this.timer = setInterval(() => {
                this.homeDate = this.$getTime()
            }, 1000);
        },
        get_data() {
            getProcSupplierApi(this.search_obj, this).then(res => {
                this.table_data = res.records
                this.total = res.total
            }).catch(() => { })
        },
        //页码发生变化时
        change_data(e) {
            this.search_obj.currentPage = e
            this.get_data()
        },
        //修改每页大小
        handleSizeChange(e) {
            this.search_obj.pageSize = e
            this.search_obj.currentPage = 1
            this.get_data()
        },
        search() {
            this.search_obj.currentPage = 1
            this.get_data()
        },
        percent_color(val) {
            if (val == null) return ''
            else if (val < 20) return '#ff3333'
            else if (val >= 20 && val <= 50) return '#ffcc00'
            else if (val == 100) return '#00cc33'
            else return '#00ccff'
        },
        countPrecent(val) {
            return val * 100
        },

    },
    mounted() {
        this.showTime()
    },
    created() {
        this.get_data()
    },
    beforeDestroy() {
        if (this.timer) {
            clearInterval(this.timer)
            this.timer = ''
        }
    },
}
</script>
<style scoped>
.proc_nav {
    height: 5%;
    display: flex;
    align-items: center;
    padding-left: 20px;
}

.nav_left {
    width: 20%;
}

.nav_right {
    display: flex;
    flex-direction: column;
    gap: 5px;
    align-items: center;
    justify-content: center;
    width: 10%;
    flex-wrap: wrap;
}

.header-text-left {
    height: 38px;
    line-height: 38px;
    font-size: 28px;
    font-weight: 700;
    font-family: '楷体';
}

.pe-header-text {
    margin-left: 10px;
    font-size: 16px;
    font-weight: 900;
    line-height: 45px;
    color: #fff;
}

.header-right {
    font-size: 14px;
    height: 19px;
    line-height: 25px;
    text-align: right;
    padding-right: 10px;
}

.proc_body {
    height: 84%;
}

.table-footer {
    height: 5%;
    display: flex;
    padding-left: 10px;
    align-items: center;
    background-color: #fff;
}


/deep/.el-table .sort-caret.ascending {
    border-bottom-color: #2e3033;
}

/deep/.el-table .ascending .sort-caret.ascending {
    border-bottom-color: #d5d9dd;
}

/deep/.el-table .sort-caret.descending {
    border-top-color: #2e3033;
}

/deep/.el-table .descending .sort-caret.descending {
    border-top-color: #d5d9dd;
}


.bg>>>.el-table--striped .el-table__body tr.el-table__row--striped td {
    background: #c3e0fb;
    border-color: #fff;
}

.nav_left>>>.el-descriptions-item__cell {
    padding: 0 5px !important;
    line-height: 2.5;
}

.bg {
    height: 100%;
}


.proc_body>>>.el-table .cell {
    padding: 0 3px;
}

.proc_body>>>.el-table__body-wrapper::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}
.proc_body>>>.el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.185);
    border-radius: 5px;
}
</style>
<style></style>
  